import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionsContext';

// PrivateRoute supports both role gating and scope gating:
//   <PrivateRoute allowedRoles={['superadmin']}>...
//   <PrivateRoute requiredScopes={['users.add']}>...   (any-of semantics)
const PrivateRoute = ({ children, role, allowedRoles, requiredScopes }) => {
  const { user, loading } = useContext(AuthContext);
  const { hasScope, loading: permsLoading } = usePermissions();

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  const roles = allowedRoles || (role ? [role] : null);
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  if (Array.isArray(requiredScopes) && requiredScopes.length > 0) {
    if (permsLoading) {
      return <div className="loading"><div className="spinner"></div></div>;
    }
    const ok = requiredScopes.some(s => hasScope(s));
    if (!ok) {
      return <Navigate to="/" />;
    }
  }

  return children;
};

export default PrivateRoute;
